// COPIA ESM de backend/data/selecciones.js. Re-copiar si cambia el backend.
// Catálogo de SELECCIONES nacionales para el modo carrera (Mundial + clasif).
//
// Cada selección: { nombre, pais, confederacion, ranking, estrellas, bombo }
// `pais` matches `career.nacionalidad`. `estrellas` se deriva del ranking.
//
// Totales en este catálogo:
//   UEFA      54  (5 bombos: 12+12+12+12+6)
//   Asia      46  (4 bombos: 8+8+8+22)
//   África    54  (6 bombos: 9+9+9+9+9+9)
//   CONCACAF  28  (4 bombos: 4+4+4+16)
//   Oceanía   11
//   Conmebol  10
//   ──────── 203

// Ranking FIFA → estrellas (según spec del feature).
export function estrellasByRanking(rank) {
    if (rank <= 5)  return 5;
    if (rank <= 10) return 4.5;
    if (rank <= 15) return 4;
    if (rank <= 25) return 3.5;
    if (rank <= 35) return 3;
    if (rank <= 45) return 2.5;
    if (rank <= 60) return 2;
    if (rank <= 80) return 1.5;
    return 1;
}

// Umbral de media para que la selección convoque, por estrellas (3 puntos menos que el FIFA real
// para que sea más accesible). 1★ siempre convoca.
export const CALLUP_THRESHOLDS = {
    5:   82,
    4.5: 80,
    4:   77,
    3.5: 75,
    3:   72,
    2.5: 68,
    2:   65,
    1.5: 60,
    1:    0,
};

// Cupos al Mundial por confederación (total = 48).
export const MUNDIAL_CUPOS = {
    UEFA:     16,
    Asia:      9,
    Africa:   10,
    CONCACAF:  6,
    Oceania:   1,
    Conmebol:  6,
};

function sel(nombre, ranking, confederacion, bombo = null, pais = null) {
    return {
        nombre,
        pais: pais || nombre,
        confederacion,
        ranking,
        estrellas: estrellasByRanking(ranking),
        bombo,
    };
}

// ── UEFA (54) ───────────────────────────────────────────────────────────────
export const UEFA = [
    // Bombo 1 (12)
    sel('Francia',           2, 'UEFA', 1),
    sel('España',            3, 'UEFA', 1),
    sel('Inglaterra',        4, 'UEFA', 1),
    sel('Portugal',          6, 'UEFA', 1),
    sel('Países Bajos',      7, 'UEFA', 1),
    sel('Bélgica',           8, 'UEFA', 1),
    sel('Italia',            9, 'UEFA', 1),
    sel('Alemania',         10, 'UEFA', 1),
    sel('Croacia',          13, 'UEFA', 1),
    sel('Suiza',            20, 'UEFA', 1),
    sel('Dinamarca',        21, 'UEFA', 1),
    sel('Austria',          22, 'UEFA', 1),
    // Bombo 2 (12)
    sel('Ucrania',          25, 'UEFA', 2),
    sel('Suecia',           27, 'UEFA', 2),
    sel('Turquía',          28, 'UEFA', 2),
    sel('Gales',            29, 'UEFA', 2),
    sel('Hungría',          30, 'UEFA', 2),
    sel('Serbia',           32, 'UEFA', 2),
    sel('Polonia',          35, 'UEFA', 2),
    sel('Rumania',          38, 'UEFA', 2),
    sel('Grecia',           39, 'UEFA', 2),
    sel('Eslovaquia',       41, 'UEFA', 2),
    sel('República Checa',  42, 'UEFA', 2),
    sel('Noruega',          43, 'UEFA', 2),
    // Bombo 3 (12)
    sel('Escocia',          45, 'UEFA', 3),
    sel('Eslovenia',        55, 'UEFA', 3),
    sel('Irlanda',          60, 'UEFA', 3),
    sel('Albania',          65, 'UEFA', 3),
    sel('Macedonia del Norte', 67, 'UEFA', 3),
    sel('Georgia',          68, 'UEFA', 3),
    sel('Finlandia',        69, 'UEFA', 3),
    sel('Islandia',         70, 'UEFA', 3),
    sel('Irlanda del Norte',71, 'UEFA', 3),
    sel('Montenegro',       73, 'UEFA', 3),
    sel('Bosnia y Herzegovina', 74, 'UEFA', 3),
    sel('Israel',           76, 'UEFA', 3),
    // Bombo 4 (12)
    sel('Bulgaria',         82, 'UEFA', 4),
    sel('Luxemburgo',       92, 'UEFA', 4),
    sel('Bielorrusia',      98, 'UEFA', 4),
    sel('Kosovo',           99, 'UEFA', 4),
    sel('Armenia',         100, 'UEFA', 4),
    sel('Kazajistán',      110, 'UEFA', 4),
    sel('Azerbaiyán',      117, 'UEFA', 4),
    sel('Estonia',         123, 'UEFA', 4),
    sel('Chipre',          130, 'UEFA', 4),
    sel('Islas Feroe',     137, 'UEFA', 4),
    sel('Letonia',         140, 'UEFA', 4),
    sel('Lituania',        142, 'UEFA', 4),
    // Bombo 5 (6)
    sel('Moldavia',        151, 'UEFA', 5),
    sel('Malta',           169, 'UEFA', 5),
    sel('Andorra',         171, 'UEFA', 5),
    sel('Gibraltar',       197, 'UEFA', 5),
    sel('Liechtenstein',   204, 'UEFA', 5),
    sel('San Marino',      210, 'UEFA', 5),
];

// ── Asia (46) ───────────────────────────────────────────────────────────────
export const ASIA = [
    // Bombo 1 (8)
    sel('Japón',                  20, 'Asia', 1),
    sel('Irán',                   22, 'Asia', 1),
    sel('Australia',              27, 'Asia', 1),
    sel('Corea del Sur',          28, 'Asia', 1),
    sel('Arabia Saudita',         54, 'Asia', 1),
    sel('Catar',                  59, 'Asia', 1),
    sel('Irak',                   67, 'Asia', 1),
    sel('Emiratos Árabes Unidos', 72, 'Asia', 1),
    // Bombo 2 (8)
    sel('Omán',         73, 'Asia', 2),
    sel('Uzbekistán',   74, 'Asia', 2),
    sel('China',        80, 'Asia', 2),
    sel('Jordania',     82, 'Asia', 2),
    sel('Baréin',       86, 'Asia', 2),
    sel('Siria',        94, 'Asia', 2),
    sel('Vietnam',      95, 'Asia', 2),
    sel('Palestina',    96, 'Asia', 2),
    // Bombo 3 (8)
    sel('Kirguistán',     97, 'Asia', 3),
    sel('India',          99, 'Asia', 3),
    sel('Líbano',        100, 'Asia', 3),
    sel('Tayikistán',    110, 'Asia', 3),
    sel('Tailandia',     113, 'Asia', 3),
    sel('Corea del Norte', 115, 'Asia', 3),
    sel('Filipinas',     135, 'Asia', 3),
    sel('Malasia',       136, 'Asia', 3),
    // Bombo 4 (22)
    sel('Kuwait',        137, 'Asia', 4),
    sel('Turkmenistán',  138, 'Asia', 4),
    sel('Hong Kong',     149, 'Asia', 4),
    sel('Indonesia',     150, 'Asia', 4),
    sel('China Taipéi',  153, 'Asia', 4),
    sel('Maldivas',      155, 'Asia', 4),
    sel('Yemen',         156, 'Asia', 4),
    sel('Afganistán',    157, 'Asia', 4),
    sel('Singapur',      158, 'Asia', 4),
    sel('Birmania',      160, 'Asia', 4),
    sel('Nepal',         175, 'Asia', 4),
    sel('Camboya',       176, 'Asia', 4),
    sel('Macao',         182, 'Asia', 4),
    sel('Mongolia',      183, 'Asia', 4),
    sel('Bután',         185, 'Asia', 4),
    sel('Laos',          187, 'Asia', 4),
    sel('Bangladés',     189, 'Asia', 4),
    sel('Brunéi',        190, 'Asia', 4),
    sel('Timor Oriental',192, 'Asia', 4),
    sel('Pakistán',      201, 'Asia', 4),
    sel('Guam',          203, 'Asia', 4),
    sel('Sri Lanka',     204, 'Asia', 4),
];

// ── África (54) ─────────────────────────────────────────────────────────────
export const AFRICA = [
    // Bombo 1 (9)
    sel('Marruecos',        13, 'Africa', 1),
    sel('Senegal',          18, 'Africa', 1),
    sel('Túnez',            31, 'Africa', 1),
    sel('Argelia',          33, 'Africa', 1),
    sel('Egipto',           34, 'Africa', 1),
    sel('Nigeria',          39, 'Africa', 1),
    sel('Camerún',          43, 'Africa', 1),
    sel('Malí',             50, 'Africa', 1),
    sel('Costa de Marfil',  51, 'Africa', 1),
    // Bombo 2 (9)
    sel('Burkina Faso',     55, 'Africa', 2),
    sel('Ghana',            59, 'Africa', 2),
    sel('Sudáfrica',        62, 'Africa', 2),
    sel('Cabo Verde',       66, 'Africa', 2),
    sel('R.D. del Congo',   69, 'Africa', 2),
    sel('Guinea',           80, 'Africa', 2),
    sel('Zambia',           84, 'Africa', 2),
    sel('Gabón',            85, 'Africa', 2),
    sel('Guinea Ecuatorial',91, 'Africa', 2),
    // Bombo 3 (9)
    sel('Uganda',           92, 'Africa', 3),
    sel('Benín',            93, 'Africa', 3),
    sel('Mauritania',       99, 'Africa', 3),
    sel('Kenia',           105, 'Africa', 3),
    sel('Congo',           106, 'Africa', 3),
    sel('Madagascar',      107, 'Africa', 3),
    sel('Guinea-Bisáu',    111, 'Africa', 3),
    sel('Namibia',         112, 'Africa', 3),
    sel('Angola',          114, 'Africa', 3),
    // Bombo 4 (9)
    sel('Mozambique',      117, 'Africa', 4),
    sel('Gambia',          119, 'Africa', 4),
    sel('Sierra Leona',    120, 'Africa', 4),
    sel('Togo',            122, 'Africa', 4),
    sel('Tanzania',        123, 'Africa', 4),
    sel('Zimbabue',        124, 'Africa', 4),
    sel('R. Centroafricana', 125, 'Africa', 4),
    sel('Malaui',          126, 'Africa', 4),
    sel('Libia',           127, 'Africa', 4),
    // Bombo 5 (9)
    sel('Níger',           128, 'Africa', 5),
    sel('Comoras',         130, 'Africa', 5),
    sel('Sudán',           131, 'Africa', 5),
    sel('Ruanda',          139, 'Africa', 5),
    sel('Burundi',         140, 'Africa', 5),
    sel('Etiopía',         143, 'Africa', 5),
    sel('Suazilandia',     146, 'Africa', 5),
    sel('Botsuana',        147, 'Africa', 5),
    sel('Liberia',         148, 'Africa', 5),
    // Bombo 6 (9)
    sel('Lesoto',          152, 'Africa', 6),
    sel('Sudán del Sur',   168, 'Africa', 6),
    sel('Mauricio',        180, 'Africa', 6),
    sel('Chad',            181, 'Africa', 6),
    sel('Santo Tomé y Príncipe', 187, 'Africa', 6),
    sel('Yibuti',          193, 'Africa', 6),
    sel('Seychelles',      196, 'Africa', 6),
    sel('Eritrea',         198, 'Africa', 6),
    sel('Somalia',         199, 'Africa', 6),
];

// ── CONCACAF (28) ───────────────────────────────────────────────────────────
export const CONCACAF = [
    // Bombo 1 (4)
    sel('Canadá',         30, 'CONCACAF', 1),
    sel('Estados Unidos', 17, 'CONCACAF', 1),
    sel('México',         14, 'CONCACAF', 1),
    sel('Panamá',         41, 'CONCACAF', 1),
    // Bombo 2 (4)
    sel('Costa Rica',     52, 'CONCACAF', 2),
    sel('Jamaica',        55, 'CONCACAF', 2),
    sel('Honduras',       76, 'CONCACAF', 2),
    sel('El Salvador',    78, 'CONCACAF', 2),
    // Bombo 3 (4)
    sel('Haití',          89, 'CONCACAF', 3),
    sel('Curazao',        90, 'CONCACAF', 3),
    sel('Trinidad y Tobago', 96, 'CONCACAF', 3),
    sel('Guatemala',     108, 'CONCACAF', 3),
    // Bombo 4 (16)
    sel('Nicaragua',     134, 'CONCACAF', 4),
    sel('Antigua y Barbuda', 142, 'CONCACAF', 4),
    sel('Surinam',       143, 'CONCACAF', 4),
    sel('San Cristóbal y Nieves', 147, 'CONCACAF', 4),
    sel('República Dominicana', 151, 'CONCACAF', 4),
    sel('Guyana',        157, 'CONCACAF', 4),
    sel('Puerto Rico',   159, 'CONCACAF', 4),
    sel('Santa Lucía',   167, 'CONCACAF', 4),
    sel('Cuba',          169, 'CONCACAF', 4),
    sel('Bermudas',      171, 'CONCACAF', 4),
    sel('San Vicente y las Granadinas', 173, 'CONCACAF', 4),
    sel('Granada',       174, 'CONCACAF', 4),
    sel('Montserrat',    176, 'CONCACAF', 4),
    sel('Barbados',      178, 'CONCACAF', 4),
    sel('Dominica',      180, 'CONCACAF', 4),
    sel('Belice',        182, 'CONCACAF', 4),
];

// ── Oceanía (11) — liga ida y vuelta ────────────────────────────────────────
export const OCEANIA = [
    sel('Nueva Zelanda',      85, 'Oceania'),
    sel('Nueva Caledonia',   151, 'Oceania'),
    sel('Islas Salomón',     153, 'Oceania'),
    sel('Fiyi',              155, 'Oceania'),
    sel('Tahití',            162, 'Oceania'),
    sel('Islas Cook',        186, 'Oceania'),
    sel('Papúa Nueva Guinea',168, 'Oceania'),
    sel('Vanuatu',           173, 'Oceania'),
    sel('Samoa',             188, 'Oceania'),
    sel('Samoa Americana',   191, 'Oceania'),
    sel('Tonga',             200, 'Oceania'),
];

// ── Conmebol (10) — liga ida y vuelta ───────────────────────────────────────
export const CONMEBOL = [
    sel('Argentina',  1, 'Conmebol'),
    sel('Brasil',     4, 'Conmebol'),
    sel('Colombia',  12, 'Conmebol'),
    sel('Uruguay',   15, 'Conmebol'),
    sel('Ecuador',   23, 'Conmebol'),
    sel('Paraguay',  41, 'Conmebol'),
    sel('Bolivia',   70, 'Conmebol'),
    sel('Chile',     75, 'Conmebol'),
    sel('Venezuela', 82, 'Conmebol'),
    sel('Perú',      90, 'Conmebol'),
];

export const SELECCIONES = [...UEFA, ...ASIA, ...AFRICA, ...CONCACAF, ...OCEANIA, ...CONMEBOL];

// País → código de bandera (flagcdn). Cubre las 203 selecciones.
export const CODIGO_PAIS = {
    // UEFA
    'Francia': 'fr', 'España': 'es', 'Inglaterra': 'gb-eng', 'Portugal': 'pt', 'Países Bajos': 'nl',
    'Bélgica': 'be', 'Italia': 'it', 'Alemania': 'de', 'Croacia': 'hr', 'Suiza': 'ch', 'Dinamarca': 'dk',
    'Austria': 'at', 'Ucrania': 'ua', 'Suecia': 'se', 'Turquía': 'tr', 'Gales': 'gb-wls', 'Hungría': 'hu',
    'Serbia': 'rs', 'Polonia': 'pl', 'Rumania': 'ro', 'Grecia': 'gr', 'Eslovaquia': 'sk', 'República Checa': 'cz',
    'Noruega': 'no', 'Escocia': 'gb-sct', 'Eslovenia': 'si', 'Irlanda': 'ie', 'Albania': 'al',
    'Macedonia del Norte': 'mk', 'Georgia': 'ge', 'Finlandia': 'fi', 'Islandia': 'is', 'Irlanda del Norte': 'gb-nir',
    'Montenegro': 'me', 'Bosnia y Herzegovina': 'ba', 'Israel': 'il', 'Bulgaria': 'bg', 'Luxemburgo': 'lu',
    'Bielorrusia': 'by', 'Kosovo': 'xk', 'Armenia': 'am', 'Kazajistán': 'kz', 'Azerbaiyán': 'az', 'Estonia': 'ee',
    'Chipre': 'cy', 'Islas Feroe': 'fo', 'Letonia': 'lv', 'Lituania': 'lt', 'Moldavia': 'md', 'Malta': 'mt',
    'Andorra': 'ad', 'Gibraltar': 'gi', 'Liechtenstein': 'li', 'San Marino': 'sm',
    // Asia
    'Japón': 'jp', 'Irán': 'ir', 'Australia': 'au', 'Corea del Sur': 'kr', 'Arabia Saudita': 'sa', 'Catar': 'qa',
    'Irak': 'iq', 'Emiratos Árabes Unidos': 'ae', 'Omán': 'om', 'Uzbekistán': 'uz', 'China': 'cn', 'Jordania': 'jo',
    'Baréin': 'bh', 'Siria': 'sy', 'Vietnam': 'vn', 'Palestina': 'ps', 'Kirguistán': 'kg', 'India': 'in',
    'Líbano': 'lb', 'Tayikistán': 'tj', 'Tailandia': 'th', 'Corea del Norte': 'kp', 'Filipinas': 'ph',
    'Malasia': 'my', 'Kuwait': 'kw', 'Turkmenistán': 'tm', 'Hong Kong': 'hk', 'Indonesia': 'id', 'China Taipéi': 'tw',
    'Maldivas': 'mv', 'Yemen': 'ye', 'Afganistán': 'af', 'Singapur': 'sg', 'Birmania': 'mm', 'Nepal': 'np',
    'Camboya': 'kh', 'Macao': 'mo', 'Mongolia': 'mn', 'Bután': 'bt', 'Laos': 'la', 'Bangladés': 'bd', 'Brunéi': 'bn',
    'Timor Oriental': 'tl', 'Pakistán': 'pk', 'Guam': 'gu', 'Sri Lanka': 'lk',
    // África
    'Marruecos': 'ma', 'Senegal': 'sn', 'Túnez': 'tn', 'Argelia': 'dz', 'Egipto': 'eg', 'Nigeria': 'ng',
    'Camerún': 'cm', 'Malí': 'ml', 'Costa de Marfil': 'ci', 'Burkina Faso': 'bf', 'Ghana': 'gh', 'Sudáfrica': 'za',
    'Cabo Verde': 'cv', 'R.D. del Congo': 'cd', 'Guinea': 'gn', 'Zambia': 'zm', 'Gabón': 'ga', 'Guinea Ecuatorial': 'gq',
    'Uganda': 'ug', 'Benín': 'bj', 'Mauritania': 'mr', 'Kenia': 'ke', 'Congo': 'cg', 'Madagascar': 'mg',
    'Guinea-Bisáu': 'gw', 'Namibia': 'na', 'Angola': 'ao', 'Mozambique': 'mz', 'Gambia': 'gm', 'Sierra Leona': 'sl',
    'Togo': 'tg', 'Tanzania': 'tz', 'Zimbabue': 'zw', 'R. Centroafricana': 'cf', 'Malaui': 'mw', 'Libia': 'ly',
    'Níger': 'ne', 'Comoras': 'km', 'Sudán': 'sd', 'Ruanda': 'rw', 'Burundi': 'bi', 'Etiopía': 'et',
    'Suazilandia': 'sz', 'Botsuana': 'bw', 'Liberia': 'lr', 'Lesoto': 'ls', 'Sudán del Sur': 'ss', 'Mauricio': 'mu',
    'Chad': 'td', 'Santo Tomé y Príncipe': 'st', 'Yibuti': 'dj', 'Seychelles': 'sc', 'Eritrea': 'er', 'Somalia': 'so',
    // CONCACAF
    'Canadá': 'ca', 'Estados Unidos': 'us', 'México': 'mx', 'Panamá': 'pa', 'Costa Rica': 'cr', 'Jamaica': 'jm',
    'Honduras': 'hn', 'El Salvador': 'sv', 'Haití': 'ht', 'Curazao': 'cw', 'Trinidad y Tobago': 'tt', 'Guatemala': 'gt',
    'Nicaragua': 'ni', 'Antigua y Barbuda': 'ag', 'Surinam': 'sr', 'San Cristóbal y Nieves': 'kn',
    'República Dominicana': 'do', 'Guyana': 'gy', 'Puerto Rico': 'pr', 'Santa Lucía': 'lc', 'Cuba': 'cu',
    'Bermudas': 'bm', 'San Vicente y las Granadinas': 'vc', 'Granada': 'gd', 'Montserrat': 'ms', 'Barbados': 'bb',
    'Dominica': 'dm', 'Belice': 'bz',
    // Oceanía
    'Nueva Zelanda': 'nz', 'Nueva Caledonia': 'nc', 'Islas Salomón': 'sb', 'Fiyi': 'fj', 'Tahití': 'pf',
    'Islas Cook': 'ck', 'Papúa Nueva Guinea': 'pg', 'Vanuatu': 'vu', 'Samoa': 'ws', 'Samoa Americana': 'as', 'Tonga': 'to',
    // Conmebol
    'Argentina': 'ar', 'Brasil': 'br', 'Colombia': 'co', 'Uruguay': 'uy', 'Ecuador': 'ec', 'Paraguay': 'py',
    'Bolivia': 'bo', 'Chile': 'cl', 'Venezuela': 've', 'Perú': 'pe',
};

// Todas las nacionalidades jugables (= todas las selecciones), ordenadas por estrellas (potencias
// primero) y luego alfabético.
export const NACIONALIDADES = [...SELECCIONES]
    .sort((a, b) => (b.estrellas - a.estrellas) || a.pais.localeCompare(b.pais))
    .map(s => s.pais);

export const SELECCIONES_BY_PAIS = Object.fromEntries(SELECCIONES.map(s => [s.pais, s]));
export const SELECCIONES_BY_CONFEDERACION = SELECCIONES.reduce((acc, s) => {
    (acc[s.confederacion] = acc[s.confederacion] || []).push(s);
    return acc;
}, {});

// Devuelve la selección del jugador según su nacionalidad. null si no la tiene.
export function seleccionDelJugador(career) {
    const nat = career?.nacionalidad;
    if (!nat) return null;
    return SELECCIONES_BY_PAIS[nat] || null;
}

// Umbral de media para que la selección convoque al jugador.
export function umbralCallup(seleccion) {
    if (!seleccion) return 999;
    return CALLUP_THRESHOLDS[seleccion.estrellas] ?? 0;
}

// ¿El jugador está convocado? Una vez que te llamaron alguna vez (jugaste al menos un partido con
// la selección) quedás convocado SIEMPRE, aunque baje tu media. Si no, se decide por la media.
export function isCalledUp(career, seleccion) {
    if (!seleccion) return false;
    if ((career?.seleccion_carrera?.partidos || 0) > 0) return true;
    const media = career?.rating ?? 0;
    return media > umbralCallup(seleccion);
}

// Aplica overrides de admin (estrellas/ranking por país) MUTANDO el catálogo en memoria. Se llama
// una vez al cargar la carrera. Afecta los próximos sorteos/ciclos (los ya guardados conservan los
// valores con los que se armaron).
export function aplicarOverridesSelecciones(overrides) {
    if (!overrides) return;
    for (const pais of Object.keys(overrides)) {
        const s = SELECCIONES_BY_PAIS[pais];
        const o = overrides[pais];
        if (!s || !o) continue;
        if (o.estrellas != null) s.estrellas = o.estrellas;
        if (o.ranking != null) s.ranking = o.ranking;
    }
}
